type AffiliateData = {
  awc: string
  affiliateMarker: string
}

export const getAffiliateDataFromCookie = (cookie: string): AffiliateData => {
  const cookies = cookie.split('; ')

  return {
    awc: cookies.find((c) => c.startsWith('awc='))?.split('=')[1] ?? '',
    affiliateMarker:
      cookies.find((c) => c.startsWith('affiliateMarker='))?.split('=')[1] ??
      '',
  }
}
